module.exports = __webpack_public_path__ + "static/media/menu-icon.7d91c5bc.svg";